import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CITY_GUIDE_CATEGORY_EDIT } from '../../../../../constants/CityGuideConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_CITY_GUIDE,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { allCityGuideCategoriesSelector, cityGuideSelector } from '../../../cmsSlice';
import './City-Guide-Category-view.scss';

const CityGuideCategoryView = (props) => {
  const { cityGuideCategory, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedCategory, setSelectedCategory] = useState(cityGuideCategory);
  const originalCityGuideCategories = useSelector(allCityGuideCategoriesSelector);
  const originalCityGuide = useSelector(cityGuideSelector);

  useEffect(() => {
    const catObj = {
      ...originalCityGuideCategories.find((cat) => cat.id === cityGuideCategory.id),
    };
    const categoryCityGuide = originalCityGuide
      .filter((item) => item.categoryId === catObj.id)
      .map((c) => c.name);
    catObj['activities'] = categoryCityGuide;

    setSelectedCategory(catObj);
  }, [originalCityGuideCategories]);

  const onClickEdit = (event) => {
    toggleDrawer(CITY_GUIDE_CATEGORY_EDIT, true, selectedCategory);
  };

  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Category Name</div>
            <div className='details-value preview-breaks'>{selectedCategory.name}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No of Activities</div>
            <div className='details-value'>{selectedCategory.activities?.length || 0}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Activities</div>
            <div className='details-value'>
              {selectedCategory.activities?.length > 0
                ? selectedCategory.activities.join(', ')
                : '---'}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {selectedCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedCategory.name}
          createdUserId={selectedCategory.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_CITY_GUIDE] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};

export default CityGuideCategoryView;
